export interface TranslationInfo {
  defaultText: string;
  token: string;
  scope?: string;
}
export function isTranslationInfo (value: unknown): value is TranslationInfo {
  if (typeof value !== 'object' || value === null) return false;

  const maybeTranslationInfo: TranslationInfo = value as TranslationInfo;

  if (typeof maybeTranslationInfo.defaultText === "string"
    && typeof maybeTranslationInfo.scope === "string"
    && typeof maybeTranslationInfo.token === "string")
    return true;

  return false;
}

